// modules
import { connect } from 'react-redux'
// components
import { EmojiPicker } from './emojiPicker.presentational'
// actions
import { dispatchSetIsOpen } from './emojiPicker.actions'
// views
import { isOpenView } from './emojiPicker.reducer'

const mapStateToProps = () => ({
  isOpen: isOpenView(),
})

const mapDispatchToProps = () => ({
  onClickAway: () => dispatchSetIsOpen(false),
})

export default connect(mapStateToProps, mapDispatchToProps)(EmojiPicker)
